import React from "react";

import { BrowserRouter, Route, Switch } from "react-router-dom";
// import { Route, Switch } from "react-router-dom";
//路由地址
import Login from "../pages/Login"; // 登录
import Home from "../pages/Home"; // 主页
import Register from "../pages/Register"; // 注册
import EditPasWed from "../pages/EditPasWed"; // 修改密码
import Comiplat from "../pages/Complaint"; // 投诉请求主页
import Volation from "../pages/Violation"; // 违法违纪问题
import Propscal from "../pages/Proposal"; // 建议征集
import QueryCenter from "../pages/Query"; // 查询评价
import PersCenter from "../pages/PerCener"; // 个人中心
import EditPhone from "../pages/editPhone"; // 修改绑定手机号码
import EditSecurity from "../pages/EditSecurity"; // 修改密保问题
import SloveThings from "../pages/SloveThings"; // 不同意某处决定
import Asscate from "../pages/Assocate"; // 联名人列表
import AddAsscate from "../pages/AddAssocate"; // 添加联名人
import SuccessCont from "./Success";
import DetialCompt from "../pages/detailCompt"; // 投诉详情
import Solicitation from "../pages/Solicitation"; // 征集详情
import MatRix from "../pages/matrix/index";
import Guide from '../pages/Guide';
import PdfWeb from '../pages/pdfweb';
import Journ from '../pages/journ';
class RouterConfig extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/guide" component={Guide} />
        <Route path="/pdfweb" component={PdfWeb} />
        <Route path="/journ" component={Journ} />
        <Route path="/login"  component={Login} />
        <Route path="/matrix"  component={MatRix} />
        <Route path="/home" component={Home} />
        <Route path="/register" component={Register} />
        <Route path="/editPaswed" component={EditPasWed} />
        <Route path="/comiplat" component={Comiplat} />
        <Route path="/vocation" component={Volation} />
        <Route path="/propscal" component={Propscal} />
        <Route path="/queryCenter" component={QueryCenter} />
        <Route path="/persCenter" component={PersCenter} />
        <Route path="/editPhone" component={EditPhone} />
        <Route path="/editSecurity" component={EditSecurity} />
        <Route path="/slovethings" component={SloveThings} />
        <Route path="/asscate" component={Asscate} />
        <Route path="/addasscate" component={AddAsscate} />
        <Route path="/success" component={SuccessCont} />
        <Route path="/detialCompt" component={DetialCompt} />
        <Route path="/solicitation" component={Solicitation} />
      </Switch>
    );
  }
}

export default RouterConfig;
